import React from 'react';
import { $_ } from '../i18n';
import { useAppConfig } from '../lib/appConfig';
import RevealEmailButton from '../components/RevealEmailButton';

const supportEmailCharCodes: number[] = [
  115, 117, 112, 112, 111, 114, 116, 64, 109, 97, 105, 108, 46, 116, 117, 98, 108, 121, 46, 97, 112, 112
];

const TermsPage: React.FC = () => {
  const { trialDays } = useAppConfig();
  const supportCopyButtonLabel = $_('page.shared.revealEmail.supportButton');
  const supportCopyAriaLabel = $_('page.shared.revealEmail.supportAriaLabel');

  return (
    <div className="container mx-auto px-4 py-16 md:py-32 md:px-10 lg:px-32 xl:max-w-6xl">
      <article className="prose dark:prose-invert xs:prose-sm sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl prose-headings:text-gray-900 prose-p:text-gray-700">
        <h1>{$_('page.terms.title')}</h1>
        <p>{$_('page.terms.welcome')}</p>

        <h2>{$_('page.terms.usageLimits.title')}</h2>
        <p>{$_('page.terms.usageLimits.description', { trialDays })}</p>

        <h2>{$_('page.terms.payments.title')}</h2>
        <p>{$_('page.terms.payments.description', { trialDays })}</p>

        <h2>{$_('page.terms.intellectualProperty.title')}</h2>
        <p>{$_('page.terms.intellectualProperty.description')}</p>

        <h2>{$_('page.terms.changes.title')}</h2>
        <p>{$_('page.terms.changes.description')}</p>

        <h2>{$_('page.terms.contact.title')}</h2>
        <p>{$_('page.terms.contact.description')}</p>
        <RevealEmailButton
          emailCharCodes={supportEmailCharCodes}
          buttonLabel={supportCopyButtonLabel}
          ariaLabel={supportCopyAriaLabel}
        />

        <h2>{$_('page.terms.dataHandlingAndPrivacy.title')}</h2>
        <p>{$_('page.terms.dataHandlingAndPrivacy.description')}</p>

        <h2>{$_('page.terms.liabilityLimitation.title')}</h2>
        <p>{$_('page.terms.liabilityLimitation.description')}</p>

        <h2>{$_('page.terms.governingLawAndJurisdiction.title')}</h2>
        <p>{$_('page.terms.governingLawAndJurisdiction.description')}</p>

        <h2>{$_('page.terms.subscriptionCancellation.title')}</h2>
        <p>{$_('page.terms.subscriptionCancellation.description')}</p>

        <h2>{$_('page.terms.customerSupport.title')}</h2>
        <p>{$_('page.terms.customerSupport.description')}</p>
        <RevealEmailButton
          emailCharCodes={supportEmailCharCodes}
          buttonLabel={supportCopyButtonLabel}
          ariaLabel={supportCopyAriaLabel}
        />

        <h2>{$_('page.terms.termination.title')}</h2>
        <p>{$_('page.terms.termination.description')}</p>
      </article>
    </div>
  );
};

export default TermsPage;
